/**
 * Merges current form values with previously stored job data from Redux and localStorage.
 * This ensures multi-step wizard fields (such as client_id, title, description) are not lost
 * when publishing or updating from the confirmation screen (/job/publish).
 */
export const mergeJobSubmissionValues = ({
  values = {},
  reduxJobsData = {},
  localStorageJobsData = null,
  localStorageFormValues = null,
} = {}) => {
  const storageJobData = localStorageJobsData || {};
  const storageFormValues = localStorageFormValues || {};
  const storedFormValues =
    reduxJobsData?.formValues || storageJobData?.formValues || storageFormValues || {};
  const storedJob = reduxJobsData?.job || storageJobData?.job || {};

  const mergedValues = {
    ...storedFormValues,
    ...values,
  };

  if (!mergedValues.client_id) {
    mergedValues.client_id =
      storedJob.client_id ||
      storedJob.client?.id ||
      storedFormValues.client_id ||
      values.client_id;
  }
  if (!mergedValues.title) {
    mergedValues.title = storedJob.title || storedFormValues.title || values.title;
  }
  if (!mergedValues.description) {
    mergedValues.description =
      storedJob.description || storedFormValues.description || values.description;
  }

  return mergedValues;
};
